import React, { Component } from 'react';
import { find } from 'lodash';
import { components } from 'react-select'
import ReactSelect from '../../common/ReactSelect';

const YouTubeContentTypes = ["All Content Types", "Art Track / Music Video", "All UGC", "UGC Shorts", "UGC Long Form"]


class YoutubeContentTypes extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		const options = YouTubeContentTypes.map(t=>({
			label: t,
			value: t == 'All Content Types' ? null : t
		}))
		let { selected, onChange, ...rest } = this.props,
			value = find(options, (option)=>option.value == selected);
		return <ReactSelect options={options} value={value} onChange={({value})=>onChange(value)} className="select-wrapper single-select yt-type-select"  {...rest}  />
	}
}

export default YoutubeContentTypes;